import React, { useEffect, useState, useRef } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import 'bootstrap/dist/css/bootstrap.min.css';

import appSettings from "../../appSettings.json";
import './Login.css';
import useFetch from '../../shared/hooks/useFetch.js';
import isFilled from '../../shared/utilities/isFilled.js';
import { setCookie, getCookie } from '../../shared/utilities/cookies.js';

const validate = (values) => {
    const errors = {}

    if(!values.email) { errors.email = 'Campo requerido' }
    if(!values.password) { errors.password = 'Campo requerido' }
    
    return errors
}

const Login = () => {
    const getToken = `${appSettings.BASE_URL.default}/authorization/get-token`;
    const navigate = useNavigate();
    const emailRef = useRef(null);
    let params = useParams();

    const[messageLogin, setMessageLogin] = useState("");
    const[successLogin, setSuccessLogin] = useState(true);
    const[showPassword, setShowPassword] = useState(false);

    const [body, setBody] = useState();
    const {serviceResponse, error, loading} = useFetch(getToken, {'Content-Type': 'application/json'}, 'POST', body)

    useEffect(() => {
        if(!loading){
            setMessageLogin(serviceResponse.message);
            setSuccessLogin(serviceResponse.success);
        }

        if(serviceResponse.success && error !== "") { setCookie("jwt", serviceResponse.data, 1) }
        else if(isFilled(params.jwt)) { setCookie("jwt", params.jwt, 1)  }

    }, [loading, serviceResponse, error])

    useEffect(() => {
        if(isFilled(getCookie("jwt"))) { navigate('/soporte') }
    }, [serviceResponse.data])

    useEffect(() => {
        if(emailRef.current) { emailRef.current.focus() }
    }, [emailRef]);

    return (
        <div className='containerLogin' style={{backgroundImage: `url("https://cdn.g2cloud.es/soporte/img/bg-3.jpg")`}}>
            <div className="cardLogin">
                <div className="d-flex flex-center mb-4">
                    <a href="#">
                        <img src="https://cdn.g2cloud.es/soporte/img/g2cloud.png" style={{verticalAlign: "middle", borderStyle: "none", maxHeight: "225px"}} alt="Logo G2Cloud" />
                    </a>
                </div>
                <div>
                    <div style={{marginBottom: "0.8rem"}}>
                        <h3 style={{fontSize: "1.5rem", fontWeight: "400"}}>g2CloudERP <span className="text-muted">Soporte</span></h3>
                        <div className="text-muted">Inicie sesión para obtener soporte de su aplicación<br/><code>GestFrut, GestStock, GestFact</code>.</div>
                    </div>
                </div>
                <Formik
                    initialValues = {{ email: '', password: ''}}

                    validate = {validate}
                    onSubmit = { (values) => {
                        setBody(JSON.stringify({
                            Origin: 'TICKETS',
                            Email: values.email,
                            Password: values.password
                        }))
                    }}
                >
                    {({ isSubmitting }) => (
                    <Form>
                        <div className='row form-group mb-3'>
                            <Field name = "email" className = "form-control" style={{padding: "0.8rem 1rem", width: "25rem", backgroundColor: "#F3F6F9", borderColor: "#F3F6F9", color: "#3F4254"}} type="email" placeholder="Email" innerRef={emailRef}/>
                        </div>
                        <ErrorMessage name="email">{msg => <div className="form-group mb-3"><span style={{color:'red'}}>{msg}</span></div>}</ErrorMessage>
                        <div className='row form-group mb-3'>
                            <div className="password-field">
                                <Field name = "password" className = "form-control" style={{padding: "0.8rem 2.5rem 0.8rem 1rem", width: "100%", backgroundColor: "#F3F6F9", borderColor: "#F3F6F9", color: "#3F4254"}} type={showPassword ? "text" : "password"} placeholder="Password"/>
                                <button
                                    type="button"
                                    className="password-toggle"
                                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <span className="material-icons">{showPassword ? "visibility_off" : "visibility"}</span>
                                </button>
                            </div>
                        </div>
                        <ErrorMessage name="password">{msg => <div className="form-group mb-3"><span style={{color:'red'}}>{msg}</span></div>}</ErrorMessage>
                        <div className = "row form-group mb-1" style={{width: "25rem"}}>
                            {!successLogin ? <Alert severity = "error">{messageLogin}</Alert> : 
                            isSubmitting ? <Alert severity = "info">Loading...</Alert> : 
                            isFilled((getCookie("jwt"))) ? <Alert severity = "success">Successful Login</Alert> : false}
                        </div>
                        <div>
                            <button className="btn btn-primary" style={{borderRadius: "5px"}}type = "submit">Entrar</button>
                        </div>
                        <p className="mt-3 text-muted font-weight-bold  mr-2" style={{fontSize: "12px"}}>© 2020  - 2026 g2Cloud ERP, S.L.</p>
                    </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}

export default Login;
